module.exports = __webpack_public_path__ + "static/media/evolution_60.b1ae8977.svg";